import { APIService } from '../api/apiService';
import type Group from '../interfaces/Group';
import type {
  CreateGroupPayload,
  GetGroupResponse,
  GetGroupsPayload,
  UpdateGroupPayload,
} from '../interfaces/GroupService';

export class GroupService extends APIService {
  /**
   * @desc Get a specific group
   * @param id
   * @return {Promise<* | undefined>}
   */
  getGroup(id: number): Promise<Group> {
    return this.request(`/group/v2/${id}`, 'GET');
  }

  /**
   * @desc Get the list of user groups
   * @param payload
   * @return {Promise<* | undefined>}
   */
  getGroups(payload: GetGroupsPayload): Promise<GetGroupResponse> {
    return this.request('/listgroups', 'POST', { ...payload });
  }

  /**
   * @desc Create a group
   * @param payload
   * @return {Promise<* | undefined>}
   */
  createGroup(payload: CreateGroupPayload): Promise<Group> {
    return this.request('/group/v2', 'POST', { ...payload });
  }

  /**
   * @desc Update a group
   * @param id
   * @param payload
   * @return {Promise<* | undefined>}
   */
  updateGroup(payload: UpdateGroupPayload): Promise<Group> {
    return this.request(`/group/v2/${payload.id}`, 'PUT', { ...payload });
  }

  /**
   * @desc Delete users
   * @param ids
   * @param query
   * @return {Promise<* | undefined>}
   */
  deleteGroups(ids: number[]) {
    return this.request(`/group`, 'DELETE', ids);
  }
}
